<div id="app-energiemonitor-content"></div>
